<template>
  <div class="goods-item">
    <div class="goods-info">
      <div>
        <div v-if="info.syzFlag / 1=== 1" class="redFlag">试用装</div>
        <div v-else-if="info.discountPrice==0" class="redFlag">赠品</div>
        
        <img :src="info.cover" alt="">

      </div>
      <div class="info-detail">
        <div class="detail-product">
          <div class="detail-title">{{info.name}}</div>
          <div class="detail-act" v-if="info.actFlag">
            <div style="display: flex">
              <div class="act-tag">{{info.actTagText}}</div>
            </div>
            <div class="act-tip" v-if="info.actType === 'FIX_PRICE' && info.minQuantity > 0">条件：单品数量≥{{info.minQuantity}}件</div>
          </div>
          <div class="detail-num">货号：{{info.skuCode}}</div>
          <div class="detail-norms">规格：{{info.spec}}</div>
        </div>
        <div class="detail-origin">原价：{{info.skuPriceY | regDecimalPoint}}元</div>
      </div>
    </div>
    <div class="purchase-info">
      <div class="info-item">
        <span>个数</span>
        <span>{{info.count}}</span>
      </div>
      <div class="info-item">
        <span>本次发货</span>
        <span>{{info.sendCount}}</span>
      </div>
      <div class="info-item">
        <span>单价(元)<span style="color: #FF2E2E;">*</span></span>
        <span style="color: #1D2C36;">{{info.discountPrice | regDecimalPoint}}</span>
      </div>
<!--      <div class="info-item">-->
<!--        <span>小计(元)</span>-->
<!--        <span style="color: #FF2E2E;">{{info.totalPrice | amount}}</span>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-item {
  $highlight-color: #ff2e2e;
  $dark-color: rgba(#1d2c36, 0.5);
  padding: 3vh 8vw 2vh;
  border-bottom: 1px solid #f5f5f5;
  background-color: #fff;
  .goods-info {
    display: flex;
    border-bottom: 1px solid #f5f5f5;
    padding-bottom: 1vh;
    img {
      width: 25vw;
      height: 25vw;
    }
    .info-detail {
      color: $dark-color;
      margin-left: 3.7vw;
      .detail-product {
        min-height: 25vw;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .detail-title {
          font-size: 15px;
          color: #1d2c36;
          font-weight: 600;
        }
        .detail-act {
          margin: 5px 0;
          font-size: 12px;
          color: $highlight-color;
          .act-tag {
            padding: 5px;
            margin-right: 5px;
            background-color: rgba($highlight-color, 0.1);
          }
        }
        .detail-num,
        .detail-norms {
          font-size: 12px;
        }
      }
      .detail-origin {
        margin-top: 1.5vh;
      }
    }
  }
  .purchase-info {
    padding-top: 0.7vh;
    color: $dark-color;
    font-size: 14px;
    .info-item {
      padding: 0.6vh 0;
      display: flex;
      justify-content: space-between;
    }
  }
}
.redFlag {
  background: #FF2E2E;
  color: #fff;
  width: 25vw;
  position: absolute;
  z-index: 50;
  text-align: center;
  font-size: 11px;
  line-height: 18px;
  margin-top: 20vw;
}
</style>



// WEBPACK FOOTER //
// src/views/share/confirm-order/components/OrderGoodsInfoItem.vue